module.exports = __webpack_public_path__ + "img/page-1-bg-statistics-report.a43bdb2c.jpg";